import { Link } from "react-router-dom"
import React from 'react'

import './style.scss'

function Directional({ paths }) {
    return (
        <div className="directional">
            <ul className="directional_list">
                <li className="directional_list_item">
                    <Link to='/' className="directional_list_item_link">
                        <i className="ti-home"></i> Trang chủ
                    </Link>
                </li>
                {
                    paths.map((item, index) => (
                        <li className="directional_list_item" key={index}>
                            <Link to={item.path} className="directional_list_item_link text-link">
                                <i className="ti-angle-right"></i> {item.name}
                            </Link>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default Directional